var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import { ButtonWrapper, ButtonCheckboxArrowIcon } from "./Button.styled";

var Button = function Button(props) {
  return React.createElement(ButtonWrapper, __assign({
    type: "button"
  }, props), React.createElement("span", null, props.children), props.hasArrow && React.createElement(ButtonCheckboxArrowIcon, {
    name: "CheckboxArrow"
  }));
};

export default Button;